var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2757 3.74683H16.448L11.7022 9.17104L17.2853 16.5522H12.9138L9.48981 12.0756L5.57203 16.5522H3.3984L8.47458 10.7504L3.11865 3.74683H7.60118L10.6961 7.83863L14.2757 3.74683ZM13.5133 15.2519H14.717L6.94713 4.97877H5.65543L13.5133 15.2519Z",
    fill: "#131316"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.8918f9ec63d3d0adf557e2ef8b9fde4a.svg";
export { ForwardRef as ReactComponent };